import { apiRequest } from './client'
import type { FiveMServer } from './types'

export const fivemApi = {
  listServers: () => apiRequest<{ data: FiveMServer[] }>('/fivem/servers'),

  createServer: (input: { name: string; host: string; port: number }) =>
    apiRequest<{ data: FiveMServer }>('/fivem/servers', { method: 'POST', body: input }),

  updateServer: (id: string, input: { name?: string; host?: string; port?: number }) =>
    apiRequest<{ data: FiveMServer }>(`/fivem/servers/${id}`, { method: 'PATCH', body: input }),

  removeServer: (id: string) => apiRequest<{ data: { success: boolean } }>(`/fivem/servers/${id}`, { method: 'DELETE' }),
}
